export default function departmentListToMap(departmentList) {
    let departmentMap = new Map();
    departmentList.forEach((department) => {
        departmentMap.set(department.id, department);
    });
    return departmentMap;
};